/* CardX Rewards – Bonusanzeige (Gratis-Zugaben, keine Rabatte) für Header, Produktseite, Warenkorb-Leiste und Warenkorbseite.
   Konfiguration: Abschnitt "CardX Rewards" (sections/cx-rewards.liquid). Beträge immer in Cent.
   Runde 15 (10.10.2026): reines Anzeige- und Informationssystem. Keine Gratisartikel im Warenkorb, keine Bestandsänderung.
   Die erreichten Boni stehen als Bestellattribute „CardX Einkaufsbonus“ und „CardX Sleeve-Auswahl“ an der Bestellung;
   vor dem Wechsel zur Kasse wird der Stand verbindlich abgeglichen. */
(() => {
  'use strict';
  const T = window.CXTheme;
  const CX = (window.CX = window.CX || {});
  if (!T) return;
  const R = Object.assign({ cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, CX.routes || {});
  const money = (c) => T.formatMoney(c);
  const esc = T.esc;
  const SH = () => window.Shopify || {};
  const previewTheme = () => !!(SH().designMode || (SH().theme && SH().theme.role && SH().theme.role !== 'main'));
  const onCartPage = document.body.classList.contains('cx-tpl-cart');
  let C = null;
  let S = null;
  let seq = 0;
  let timer = null;
  let syncing = false;
  let blocked = false;
  const lastFill = {};
  /* Bestellattribute (in der Bestellung unter „Zusätzliche Details“) */
  const ATTR = 'CardX Einkaufsbonus';
  const ATTR_SLV = 'CardX Sleeve-Auswahl';
  const LEGACY = ['CardX Rewards', 'CardX Rewards Sleeves', '_cx_rw_choice'];

  const P = {
    gift: '<path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 21V7"/><path d="M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/>',
    booster: '<rect x="6" y="3" width="12" height="18" rx="2"/><path d="M6 7h12M6 17h12"/><path d="M12 9.6l1.7 2.4-1.7 2.4-1.7-2.4z"/>',
    sleeves: '<rect x="8" y="2.5" width="11" height="15" rx="1.8"/><path d="M5 6.5v12A2.5 2.5 0 0 0 7.5 21H15"/>',
    star: '<path d="M12 3l2.6 5.6 6 .7-4.5 4.1 1.2 6L12 16.4l-5.3 3 1.2-6-4.5-4.1 6-.7z"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    lock: '<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>',
    close: '<path d="M6 6l12 12M18 6L6 18"/>',
    truck: '<path d="M3 6h11v10H3zM14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
  };
  const svg = (n, s) =>
    '<svg class="cx-rw-i" width="' + (s || 20) + '" height="' + (s || 20) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (P[n] || P.gift) + '</svg>';

  /* ---------- Konfiguration ---------- */
  function readConfig() {
    const el = document.getElementById('cx-rewards-config');
    if (!el) return null;
    try {
      const c = JSON.parse(el.textContent);
      c.excludeTypes = (c.excludeTypes || '').split(',').map((s) => s.trim().toLowerCase()).filter(Boolean);
      c.tiers = (c.tiers || []).filter((t) => t.on && t.min > 0).sort((a, b) => a.min - b.min);
      c.tiers.forEach((t) => {
        t.kind = t.kind || 'gift';
        if (t.kind === 'shipping') t.products = [];
      });
      return c;
    } catch (e) {
      return null;
    }
  }
  const visible = () => !!C && C.tiers.length > 0 && (C.mode === 'live' || (C.mode === 'preview' && previewTheme()));

  /* Testwerte nur in der Vorschau: ?cx_rewards_demo=399 (aus: ?cx_rewards_demo=off) */
  function demoValue() {
    if (!previewTheme()) return null;
    try {
      const p = new URLSearchParams(location.search).get('cx_rewards_demo');
      if (p !== null) {
        if (p === 'off' || p === '') sessionStorage.removeItem('cx-rw-demo');
        else sessionStorage.setItem('cx-rw-demo', String(Math.round(parseFloat(p.replace(',', '.')) * 100)));
      }
      const v = sessionStorage.getItem('cx-rw-demo');
      return v !== null && isFinite(+v) ? Math.max(0, +v) : null;
    } catch (e) {
      return null;
    }
  }

  /* ---------- Berechnung ---------- */
  const isGift = (it) => !!(it.properties && it.properties._cx_reward);
  function eligible(cart) {
    let all = 0;
    let el = 0;
    (cart.items || []).forEach((it) => {
      if (isGift(it)) return;
      const p = Math.round(Number(it.final_line_price) || 0);
      all += p;
      if (it.gift_card) return;
      if (C.excludeTypes.indexOf(String(it.product_type || '').trim().toLowerCase()) > -1) return;
      el += p;
    });
    let od = 0;
    (cart.cart_level_discount_applications || []).forEach((d) => (od += Math.round(Number(d.total_allocated_amount) || 0)));
    if (all > 0 && od > 0) el -= Math.floor((od * el) / all);
    return Math.max(0, el);
  }
  /* Auswahl (z. B. Sleeve-Größe): im Browser gemerkt und als Klartext-Attribut „CardX Sleeve-Auswahl“ an der Bestellung.
     Kein verstecktes Technik-Attribut mehr – so steht die Wahl nur einmal in der Bestellung. */
  const CHOICE_KEY = 'cx-rw-choice';
  let choiceMem = null;
  const labelsOf = (t) => String(t.choiceLabels || '').split(',').map((x) => x.trim());
  function choices(cart) {
    if (choiceMem) return Object.assign({}, choiceMem);
    let out = {};
    try {
      out = JSON.parse(localStorage.getItem(CHOICE_KEY) || '{}') || {};
    } catch (e) {
      out = {};
    }
    const attrs = (cart && cart.attributes) || {};
    if (!Object.keys(out).length && C) {
      const label = attrs[ATTR_SLV] || attrs['CardX Rewards Sleeves'];
      if (label)
        C.tiers.forEach((t) => {
          const i = t.choice ? labelsOf(t).indexOf(label) : -1;
          if (i > -1) out[t.id] = i;
        });
      String(attrs._cx_rw_choice || '').split(',').forEach((p) => {
        const kv = p.split(':');
        if (kv.length === 2 && out[kv[0]] == null) out[kv[0]] = Number(kv[1]) || 0;
      });
    }
    if (cart) choiceMem = out;
    return Object.assign({}, out);
  }
  function saveChoice(id, i) {
    const m = choices(S && S.cart);
    m[id] = i;
    choiceMem = m;
    try {
      localStorage.setItem(CHOICE_KEY, JSON.stringify(m));
    } catch (e) {
      /* Speicher nicht verfügbar – Auswahl gilt für diesen Seitenaufruf und steht im Bestellattribut */
    }
  }
  const prodAvail = (p) => (p.variants || []).some((v) => v.available);
  function choiceIndex(t, cart) {
    const ps = t.products || [];
    let i = choices(cart)[t.id];
    if (i == null || !ps[i] || !prodAvail(ps[i])) i = ps.findIndex(prodAvail);
    return i;
  }
  function variantFor(t, cart) {
    const ps = t.products || [];
    const list = t.choice ? (ps[choiceIndex(t, cart)] ? [ps[choiceIndex(t, cart)]] : []) : ps;
    for (const p of list) for (const v of p.variants || []) if (v.available) return v;
    return null;
  }
  const soldOut = (t) => (t.products || []).length > 0 && !(t.products || []).some(prodAvail);

  function compute(value, cart, demo) {
    const list = C.tiers;
    const reached = list.filter((t) => value >= t.min);
    const granted = C.cumulative ? reached.filter((t) => !soldOut(t)) : reached.filter((t) => !soldOut(t)).slice(-1);
    const next = list.find((t) => value < t.min && !soldOut(t)) || null;
    const prevMin = reached.length ? reached[reached.length - 1].min : 0;
    const ring = next ? Math.max(0, Math.min(1, (value - prevMin) / (next.min - prevMin))) : reached.length ? 1 : 0;
    let frac = 1;
    const idx = reached.length;
    if (idx < list.length) frac = (idx + (value - prevMin) / (list[idx].min - prevMin)) / list.length;
    const groups = {};
    granted.forEach((t) => {
      const g = t.group || t.title;
      groups[g] = t.kind === 'shipping' ? 0 : (groups[g] || 0) + (t.qty || 1);
    });
    return { value, cart, demo, list, reached, granted, next, ring, frac: Math.max(0, Math.min(1, frac)), groups };
  }

  /* ---------- Bausteine ---------- */
  const fill = (s, n, v) => String(s || '').replace('[betrag]', '<strong>' + money(n.min - v) + '</strong>').replace('[praemie]', esc(n.title));
  const message = (st) => {
    if (st.next) return fill(esc(st.next.text || C.text.next), st.next, st.value);
    if (!st.reached.length) return '';
    /* Sind erreichte Stufen vergriffen, nicht „Alle Boni freigeschaltet“ versprechen */
    return st.reached.some(soldOut) ? 'Alle verfügbaren Boni freigeschaltet – einzelne Gratis-Zugaben sind derzeit vergriffen.' : esc(C.text.all);
  };
  const summary = (st) =>
    Object.keys(st.groups).map((g) => (st.groups[g] ? st.groups[g] + '× ' : '') + esc(g)).join(' · ');
  const media = (t, s) => (t.image ? '<img src="' + esc(t.image) + '" alt="" width="' + s + '" height="' + s + '" loading="lazy">' : svg(t.icon, Math.round(s * 0.55)));
  const demoTag = (st) => (st.demo ? '<span class="cx-rw-demo">Demo-Wert</span>' : '');
  const preview = () => (C.mode === 'preview' && C.text.preview ? '<p class="cx-rw__preview">' + esc(C.text.preview) + '</p>' : '');
  function status(t, st) {
    if (st.value >= t.min && !soldOut(t)) return ['is-reached', esc(C.text.reached)];
    if (soldOut(t)) return ['is-out', 'Derzeit vergriffen'];
    return [st.next === t ? 'is-next' : 'is-locked', 'noch ' + money(t.min - st.value)];
  }
  function choiceUi(t, st) {
    if (!t.choice || (t.products || []).length < 2) return '';
    const labels = labelsOf(t);
    const cur = choiceIndex(t, st.cart);
    return (
      '<div class="cx-rw-choice" role="radiogroup" aria-label="Auswahl für ' + esc(t.title) + '">' +
      t.products.map((p, i) => {
        const ok = prodAvail(p);
        return '<button type="button" role="radio" class="cx-rw-choice__opt" data-cx-rw-choice="' + esc(t.id) + ':' + i + '" aria-checked="' + (i === cur) + '"' + (ok ? '' : ' disabled') + '>' + esc(labels[i] || p.title) + (ok ? '' : ' (vergriffen)') + '</button>';
      }).join('') +
      '</div>'
    );
  }
  function bar(st, key) {
    const n = st.list.length;
    const ticks = st.list.map((t, i) => '<li class="' + (st.value >= t.min ? 'is-reached' : '') + (t.kind === 'shipping' ? ' is-ship' : '') + '" style="--x:' + ((i + 1) / n) * 100 + '%"><i>' + svg(t.icon, 12) + '</i><span>' + money(t.min).replace(/,00\s/, ' ') + '</span></li>').join('');
    return (
      '<div class="cx-rw-bar" role="progressbar" aria-label="Fortschritt CardX Rewards" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(st.frac * 100) + '">' +
      '<div class="cx-rw-bar__track"><span class="cx-rw-bar__fill" data-cx-rw-fill="' + key + '" style="--p:' + (lastFill[key] != null ? lastFill[key] : 0) + '"></span></div>' +
      '<ol class="cx-rw-bar__ticks" aria-hidden="true">' + ticks + '</ol></div>'
    );
  }
  const chips = (st) =>
    st.granted.length ? '<ul class="cx-rw-chips" role="list">' + st.granted.map((t) => '<li>' + svg('check', 14) + esc(t.title) + '</li>').join('') + '</ul>' : '';
  const choicesReached = (st) => st.granted.map((t) => choiceUi(t, st)).join('');

  function compact(st, key) {
    return (
      '<div class="cx-rw cx-rw--' + key + '">' +
      '<div class="cx-rw__top"><p class="cx-rw__title">' + svg('gift', 18) + esc(C.text.title) + demoTag(st) + '</p>' +
      '<p class="cx-rw__value"><span>' + esc(C.text.valueLabel) + '</span> <strong>' + money(st.value) + '</strong></p></div>' +
      '<p class="cx-rw__msg">' + message(st) + '</p>' + bar(st, key) + chips(st) + choicesReached(st) +
      (key === 'pop' ? tierList(st) + '<a class="cx-btn cx-btn--ghost cx-btn--block cx-rw__cta" href="' + esc(R.cart) + '#cx-rewards">' + esc(C.text.cartLink) + '</a>' : '') +
      (key === 'drawer' ? '<a class="cx-rw__more" href="' + esc(R.cart) + '#cx-rewards">' + esc(C.text.allTiers) + '</a>' : '') +
      (key === 'summary' ? '<a class="cx-rw__more" href="#cx-rewards">' + esc(C.text.allTiers) + '</a>' : '') +
      preview() + '</div>'
    );
  }
  function tierList(st) {
    return (
      '<ol class="cx-rw-list" role="list">' +
      st.list.map((t) => {
        const s = status(t, st);
        return '<li class="' + s[0] + '"><span class="cx-rw-list__ico">' + svg(s[0] === 'is-reached' ? 'check' : t.icon, 16) + '</span><span class="cx-rw-list__txt"><strong>' + esc(t.title) + '</strong><small>ab ' + money(t.min) + '</small></span><span class="cx-rw-list__st">' + s[1] + '</span></li>';
      }).join('') +
      '</ol>'
    );
  }
  function product(st) {
    const sum = summary(st);
    return (
      '<div class="cx-rw cx-rw--product"><span class="cx-rw__ico">' + svg('gift', 20) + '</span><div class="cx-rw__body">' +
      '<p class="cx-rw__msg">' + message(st) + demoTag(st) + '</p>' +
      '<div class="cx-rw-mini" aria-hidden="true"><span data-cx-rw-fill="product" style="--p:' + (lastFill.product != null ? lastFill.product : 0) + '"></span></div>' +
      '<p class="cx-rw__sub">' + (sum ? esc(C.text.unlocked) + ' ' + sum + ' · ' : '') + '<button type="button" class="cx-rw__link" data-cx-rw-open>' + esc(C.text.allTiers) + '</button></p>' +
      '</div></div>'
    );
  }
  function cartView(st) {
    const rows = st.list.slice().reverse().map((t) => {
      const s = status(t, st);
      const node = s[0] === 'is-reached' ? 'check' : s[0] === 'is-locked' || s[0] === 'is-out' ? 'lock' : t.icon;
      return (
        '<li class="cx-rw-tier ' + s[0] + '"><span class="cx-rw-tier__node">' + svg(node, 16) + '</span><div class="cx-rw-tier__card">' +
        '<span class="cx-rw-tier__media">' + media(t, 56) + '</span><div class="cx-rw-tier__txt"><p class="cx-rw-tier__min">ab ' + money(t.min) + '</p>' +
        '<p class="cx-rw-tier__title">' + esc(t.title) + '</p>' + (t.desc ? '<p class="cx-rw-tier__desc">' + esc(t.desc) + '</p>' : '') + choiceUi(t, st) + '</div>' +
        '<span class="cx-rw-tier__status">' + (s[0] === 'is-reached' ? svg('check', 14) : '') + s[1] + '</span></div></li>'
      );
    }).join('');
    const sum = summary(st);
    return (
      '<section class="cx-rw cx-rw--cart" aria-labelledby="cx-rw-cart-t"><div class="cx-rw-cart__head"><div>' +
      '<p class="cx-rw__eyebrow">' + svg('gift', 16) + esc(C.text.title) + demoTag(st) + '</p><h2 id="cx-rw-cart-t">' + esc(C.text.cartHeading) + '</h2>' +
      (C.text.intro ? '<p class="cx-rw__intro">' + esc(C.text.intro) + '</p>' : '') + '</div>' +
      '<p class="cx-rw-cart__value"><span>' + esc(C.text.valueLabel) + '</span><strong>' + money(st.value) + '</strong></p></div>' +
      '<p class="cx-rw__msg">' + message(st) + '</p>' +
      '<div class="cx-rw-thermo"><div class="cx-rw-thermo__tube" aria-hidden="true"><span class="cx-rw-thermo__fill"></span></div>' +
      '<ol class="cx-rw-thermo__list" role="list">' + rows + '</ol>' +
      '<div class="cx-rw-thermo__base"><span class="cx-rw-thermo__bulb">' + svg('gift', 18) + '</span><span>' + money(0) + '</span></div></div>' +
      (sum ? '<p class="cx-rw__sum">' + svg('star', 16) + esc(C.text.unlocked) + ' <strong>' + sum + '</strong></p>' : '') +
      (C.text.note ? '<p class="cx-rw__note">' + esc(C.text.note) + '</p>' : '') + preview() + '</section>'
    );
  }

  /* ---------- Darstellung ---------- */
  function animateFills(root) {
    root.querySelectorAll('[data-cx-rw-fill]').forEach((el) => {
      const key = el.dataset.cxRwFill;
      const to = key === 'product' ? S.ring : S.frac;
      void el.offsetWidth;
      el.style.setProperty('--p', to);
      lastFill[key] = to;
    });
  }
  function layoutThermo(root) {
    const th = root.querySelector('.cx-rw-thermo');
    if (!th || !S) return;
    const box = th.getBoundingClientRect();
    const cy = (el) => {
      const r = el.getBoundingClientRect();
      return r.top + r.height / 2 - box.top;
    };
    const nodes = Array.from(th.querySelectorAll('.cx-rw-tier__node')).reverse();
    const y0 = cy(th.querySelector('.cx-rw-thermo__bulb'));
    const ys = nodes.map(cy);
    const top = ys.length ? ys[ys.length - 1] : y0;
    const tube = th.querySelector('.cx-rw-thermo__tube');
    tube.style.top = top + 'px';
    tube.style.height = Math.max(0, y0 - top) + 'px';
    let y = y0;
    let pm = 0;
    let py = y0;
    for (let i = 0; i < S.list.length; i++) {
      const m = S.list[i].min;
      if (S.value >= m) {
        y = ys[i];
        pm = m;
        py = ys[i];
        continue;
      }
      y = py + ((ys[i] - py) * (S.value - pm)) / (m - pm);
      break;
    }
    const f = tube.firstElementChild;
    const h = Math.max(0, y0 - y);
    f.style.height = (lastFill.thermo || 0) + 'px';
    void f.offsetWidth;
    f.style.height = h + 'px';
    lastFill.thermo = h;
  }
  let ro = null;
  function paintSlot(slot, html, key) {
    slot.innerHTML = html;
    slot.hidden = false;
    animateFills(slot);
    if (key === 'cart') {
      layoutThermo(slot);
      requestAnimationFrame(() => layoutThermo(slot));
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => layoutThermo(slot));
      if (window.ResizeObserver && !ro) {
        ro = new ResizeObserver(() => layoutThermo(slot));
        ro.observe(slot);
      }
    }
  }

  function header() {
    const slot = document.querySelector('[data-cx-rewards-slot="header"]');
    if (!slot) return;
    let btn = slot.querySelector('[data-cx-rw-toggle]');
    if (!btn) {
      slot.innerHTML =
        '<button type="button" class="cx-iconbtn cx-rw-hbtn" data-cx-rw-toggle aria-haspopup="dialog" aria-expanded="false" aria-controls="cx-rw-pop">' +
        '<svg class="cx-rw-ring" viewBox="0 0 36 36" aria-hidden="true"><circle cx="18" cy="18" r="16"/><circle class="cx-rw-ring__bar" cx="18" cy="18" r="16"/></svg>' +
        svg('gift', 18) + '<span class="cx-rw-hbtn__badge" hidden></span></button>';
      btn = slot.firstElementChild;
      const pop = document.createElement('div');
      pop.className = 'cx-rw-pop';
      pop.id = 'cx-rw-pop';
      pop.hidden = true;
      pop.setAttribute('role', 'dialog');
      pop.setAttribute('aria-label', C.text.title);
      pop.innerHTML = '<button type="button" class="cx-iconbtn cx-rw-pop__close" data-cx-rw-close aria-label="Schließen">' + svg('close', 18) + '</button><div data-cx-rw-pop-body></div>';
      (slot.closest('[data-cx-header]') || document.body).appendChild(pop);
    }
    slot.hidden = false;
    const n = S.granted.length;
    const badge = btn.querySelector('.cx-rw-hbtn__badge');
    badge.hidden = n === 0;
    badge.textContent = S.next ? n : '✓';
    btn.classList.toggle('is-complete', !S.next && n > 0);
    btn.style.setProperty('--ring', S.ring);
    const label = C.text.title + ': ' + (S.next ? 'noch ' + money(S.next.min - S.value) + ' bis ' + S.next.title : S.reached.some(soldOut) ? 'Alle verfügbaren Boni freigeschaltet' : C.text.all);
    btn.setAttribute('aria-label', label);
    btn.title = label;
    const body = document.querySelector('[data-cx-rw-pop-body]');
    if (body) paintSlot(body, compact(S, 'pop'), 'pop');
  }
  function productSlot() {
    if (!C.show.product) return null;
    let slot = document.querySelector('[data-cx-rewards-slot="product"]');
    if (!slot) {
      const form = document.querySelector('[data-cx-product] form[data-cx-product-form]');
      if (!form) return null;
      slot = document.createElement('div');
      slot.className = 'cx-rw-slot';
      slot.dataset.cxRewardsSlot = 'product';
      form.insertAdjacentElement('afterend', slot);
    }
    return slot;
  }
  function paint() {
    if (!S || !visible()) return;
    if (C.show.header) header();
    const p = productSlot();
    if (p) paintSlot(p, product(S), 'product');
    const d = document.querySelector('[data-cx-rewards-slot="drawer"]');
    if (d && C.show.drawer) paintSlot(d, compact(S, 'drawer'), 'drawer');
    const c = document.querySelector('[data-cx-rewards-slot="cart"]');
    if (c && C.show.cart) paintSlot(c, cartView(S), 'cart');
    const sm = document.querySelector('[data-cx-rewards-slot="summary"]');
    if (sm && C.show.cart) paintSlot(sm, compact(S, 'summary'), 'summary');
  }
  function apply(cart, skipSync) {
    const demo = demoValue();
    S = compute(demo != null ? demo : eligible(cart), cart, demo != null);
    paint();
    if (demo == null && cart && cart.items) syncAttrs(S);
    if (!skipSync && demo == null && !syncing) maybeSync(cart);
  }

  /* ---------- Bonus an der Bestellung (Warenkorb-Attribute → Bestellung „Zusätzliche Details“) ----------
     „CardX Einkaufsbonus“: erreichte Gratis-Zugaben in Klartext, z. B.
       Gratis-Sleeves: Standard · Gratisversand (Deutschland) · 3 Gratis-Booster · Warenwert lt. Warenkorb: 1.000,00 €
     „CardX Sleeve-Auswahl“: Standard / Japanisch (nur ab der Sleeves-Stufe).
     Unter der ersten Stufe werden beide Attribute entfernt. Keine Bestellpositionen, keine Bestandsänderung. */
  let attrTimer = null;
  let attrSent = null;
  function attrValues(st) {
    const out = { info: '', sleeves: '' };
    if (!st.granted.length) return out;
    const parts = [];
    const qty = {};
    const lab = {};
    st.granted.forEach((t) => {
      if (t.kind === 'shipping') {
        parts.push(t.title);
        return;
      }
      const g = t.group || t.title;
      if (t.choice && (t.products || []).length) {
        const i = choiceIndex(t, st.cart);
        const l = i > -1 ? labelsOf(t)[i] || (t.products[i] && t.products[i].title) || '' : '';
        if (l) {
          lab[g] = l;
          if (!out.sleeves && (t.icon === 'sleeves' || /sleeve/i.test(g))) out.sleeves = l;
        }
      }
      if (qty[g] == null) {
        qty[g] = 0;
        parts.push({ g, t });
      }
      qty[g] += t.qty || 1;
    });
    const text = parts.map((p) => {
      if (typeof p === 'string') return p;
      const n = qty[p.g];
      if (p.t.choice && lab[p.g]) return (n > 1 ? n + ' × ' : '') + p.g + ': ' + lab[p.g];
      return n + ' ' + p.g;
    });
    out.info = (C.mode === 'preview' ? 'VORSCHAU – keine Beilage · ' : '') + text.join(' · ') + ' · Warenwert lt. Warenkorb: ' + money(st.value);
    return out;
  }
  /* Nur geänderte Werte senden; alte Attributnamen (bis Runde 14) werden dabei entfernt */
  function attrPayload(want, have) {
    have = have || {};
    const a = {};
    let diff = false;
    if ((have[ATTR] || '') !== want.info) {
      a[ATTR] = want.info;
      diff = true;
    }
    if ((have[ATTR_SLV] || '') !== want.sleeves) {
      a[ATTR_SLV] = want.sleeves;
      diff = true;
    }
    LEGACY.forEach((k) => {
      if (have[k]) {
        a[k] = '';
        diff = true;
      }
    });
    return diff ? a : null;
  }
  function syncAttrs(st) {
    if (C.attrs === false || !visible() || !st.cart) return;
    const payload = attrPayload(attrValues(st), st.cart.attributes);
    if (!payload) {
      attrSent = null;
      return;
    }
    const key = JSON.stringify(payload);
    if (attrSent === key) return;
    clearTimeout(attrTimer);
    attrTimer = setTimeout(() => {
      attrSent = key;
      post(R.cart + '/update', { attributes: payload })
        .then((c) => {
          if (c && c.attributes && st.cart) st.cart.attributes = c.attributes;
        })
        .catch(() => {
          attrSent = null;
        });
    }, 250);
  }
  const getCart = () => fetch(R.cart + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((r) => r.json());
  function refresh(cart) {
    if (!C) return;
    if (cart && cart.items) {
      seq++;
      return apply(cart);
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      const my = ++seq;
      getCart().then((c) => my === seq && apply(c)).catch(() => {});
    }, 120);
  }

  /* ---------- Gratisartikel automatisch hinzufügen (nur wenn Shopify sie an der Kasse auf 0 € setzt) ---------- */
  const post = (url, body) =>
    fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json());
  function maybeSync(cart) {
    const hasGifts = (cart.items || []).some(isGift);
    if (hasGifts || (C.autoAdd && C.mode === 'live' && !blocked)) sync(cart);
  }
  async function sync(cart) {
    syncing = true;
    let changed = false;
    try {
      const st = compute(eligible(cart), cart, false);
      const want = {};
      if (C.autoAdd && C.mode === 'live' && !blocked)
        st.granted.forEach((t) => {
          const v = variantFor(t, cart);
          if (v) want[t.id] = { id: v.id, qty: t.qty || 1 };
        });
      const have = {};
      for (const it of cart.items) {
        const id = isGift(it) && it.properties._cx_reward;
        if (!id) continue;
        const w = want[id];
        if (!w || w.id !== it.variant_id || have[id]) {
          await post(R.cartChange, { id: it.key, quantity: 0 });
          changed = true;
        } else {
          have[id] = 1;
          if (it.quantity !== w.qty) {
            await post(R.cartChange, { id: it.key, quantity: w.qty });
            changed = true;
          }
        }
      }
      const add = Object.keys(want).filter((id) => !have[id]).map((id) => ({ id: want[id].id, quantity: want[id].qty, properties: { _cx_reward: id } }));
      if (add.length) {
        await post(R.cartAdd, { items: add });
        changed = true;
      }
      let fresh = changed ? await getCart() : cart;
      /* Sicherheitsprüfung: Ein Bonusartikel darf nie Geld kosten. Setzt Shopify ihn nicht auf 0 €, wird er entfernt. */
      const paid = fresh.items.filter((it) => isGift(it) && it.final_line_price > 0);
      if (paid.length) {
        blocked = true;
        for (const it of paid) await post(R.cartChange, { id: it.key, quantity: 0 });
        console.warn('[CardX Rewards] Bonusartikel kostet Geld und wurde entfernt. „Kaufe X, erhalte Y“-Regel in Shopify prüfen.');
        fresh = await getCart();
        changed = true;
      }
      if (changed) {
        if (onCartPage) return location.reload();
        T.refreshCartCount(fresh.item_count);
        document.dispatchEvent(new CustomEvent('cx:cart:refresh'));
        seq++;
        apply(fresh, true);
      }
    } catch (e) {
      /* Netzwerkfehler: Anzeige bleibt, nächster Abgleich bei der nächsten Änderung */
    } finally {
      syncing = false;
    }
  }

  /* ---------- Bedienung ---------- */
  const pop = () => document.getElementById('cx-rw-pop');
  function openPop(open) {
    const el = pop();
    const btn = document.querySelector('[data-cx-rw-toggle]');
    if (!el || !btn) return;
    el.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    if (open) {
      el.querySelectorAll('[data-cx-rw-fill]').forEach((f) => f.style.setProperty('--p', 0));
      void el.offsetWidth;
      el.classList.add('is-open');
      animateFills(el);
    } else el.classList.remove('is-open');
  }
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-cx-rw-toggle]')) return openPop(pop() && pop().hidden);
    if (t.closest('[data-cx-rw-open]')) {
      window.scrollTo({ top: 0, behavior: T.reduceMotion ? 'auto' : 'smooth' });
      return openPop(true);
    }
    if (t.closest('[data-cx-rw-close]')) return openPop(false);
    const ch = t.closest('[data-cx-rw-choice]');
    if (ch && S) {
      const kv = ch.dataset.cxRwChoice.split(':');
      saveChoice(kv[0], Number(kv[1]));
      if (S.cart) apply(S.cart, true);
      else paint();
      return;
    }
    if (pop() && !pop().hidden && !t.closest('#cx-rw-pop')) openPop(false);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && pop() && !pop().hidden) {
      openPop(false);
      const b = document.querySelector('[data-cx-rw-toggle]');
      if (b) b.focus();
    }
  });
  document.addEventListener('cx:cart:changed', (e) => refresh(e.detail && e.detail.cart));
  document.addEventListener('cx:cart:rendered', () => paint());
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    leaving = false;
    refresh();
  });
  document.addEventListener('visibilitychange', () => document.visibilityState === 'visible' && refresh());
  document.addEventListener('shopify:section:load', () => {
    C = readConfig();
    if (S) apply(S.cart || { items: [] }, true);
  });

  /* ---------- Vor dem Wechsel zur Kasse: Bonusinfo verbindlich an den Warenkorb übergeben ----------
     Gilt für „Zur Kasse“ in der Warenkorb-Leiste und auf der Warenkorbseite. Erst Mengen übernehmen, dann den Bonus
     aus dem aktuellen Warenkorb berechnen und speichern, dann weiter zur Kasse. Bei Netzwerkfehlern spätestens nach 4 s
     trotzdem zur Kasse – der Kauf wird nie blockiert. */
  let leaving = false;
  document.addEventListener(
    'submit',
    (e) => {
      const f = e.target;
      const sub = e.submitter;
      if (leaving || !(f instanceof HTMLFormElement) || !sub || sub.name !== 'checkout') return;
      if (!C || C.attrs === false || !visible()) return;
      e.preventDefault();
      leaving = true;
      let done = false;
      let guard = null;
      const go = () => {
        if (done) return;
        done = true;
        clearTimeout(guard);
        const i = document.createElement('input');
        i.type = 'hidden';
        i.name = 'checkout';
        i.value = sub.value || '';
        f.appendChild(i);
        HTMLFormElement.prototype.submit.call(f);
      };
      guard = setTimeout(go, 4000);
      (async () => {
        try {
          clearTimeout(attrTimer);
          const hasUpdates = !!f.querySelector('[name="updates[]"]');
          const cart = hasUpdates
            ? await fetch(R.cart + '/update.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) }).then((r) => r.json())
            : await getCart();
          if (cart && cart.items) {
            const payload = attrPayload(attrValues(compute(eligible(cart), cart, false)), cart.attributes);
            if (payload) await post(R.cart + '/update', { attributes: payload });
          }
        } catch (err) {
          /* Kasse trotzdem öffnen */
        }
        go();
      })();
    },
    true
  );

  function init() {
    C = readConfig();
    if (!C || !visible()) return;
    const demo = demoValue();
    S = compute(demo != null ? demo : C.initial || 0, null, demo != null);
    paint();
    if (location.hash === '#cx-rewards') {
      const target = document.getElementById('cx-rewards');
      if (target) target.scrollIntoView();
    }
    refresh();
  }
  CX.rewards = {
    refresh,
    state: () => S,
    config: () => C,
    compute: (v) => compute(v, S && S.cart, false),
    eligible: (c) => eligible(c),
    /* Prüfhilfe: Bestellattribute für einen Warenwert in Cent (ändert nichts) */
    orderInfo: (v) => attrValues(compute(v, S && S.cart, false)),
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
